/**
 * Clamps a typed quantity to a whole number of at least `min` (1 when `min` is absent or not a
 * number).
 *
 * A quantity field is free-typed and the product form is `novalidate`, so `min="1"` constrains
 * only the +/- buttons: a typed `0` reaches `/cart/add.js`, which answers 200, returns sections
 * without a line item and adds nothing.
 */
export const clampQuantity = (value: unknown, min: unknown = 1): number => {
  const minimum = Number.parseInt(String(min), 10) || 1;
  const quantity = Number.parseInt(String(value), 10);

  return Number.isInteger(quantity) ? Math.max(quantity, minimum) : minimum;
};
